import React, { useState } from "react";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const res = await fetch(
        "https://apimyshop.myidealtd.co.uk/api/users/forgot-password",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Something went wrong.");
      } else {
        setSuccess(
          "If this email exists, a reset link has been sent."
        );
        setEmail("");
      }
    } catch {
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <style>{`
        .forgot-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;

          background:
            radial-gradient(circle at top left, rgba(59,130,246,0.25), transparent 40%),
            radial-gradient(circle at bottom right, rgba(124,58,237,0.25), transparent 40%),
            linear-gradient(135deg, #0f172a, #020617);
        }

        /* GLASS CARD */
        .card {
          width: 100%;
          max-width: 460px;

          padding: 32px;
          border-radius: 28px;

          background: rgba(255,255,255,0.08);
          backdrop-filter: blur(25px);
          -webkit-backdrop-filter: blur(25px);

          border: 1px solid rgba(255,255,255,0.08);

          box-shadow: 0 40px 100px rgba(0,0,0,0.5);
        }

        /* HEADER */
        .title {
          font-size: 2rem;
          font-weight: 900;
          letter-spacing: -1px;
          color: #fff;
          text-align: center;
        }

        .subtitle {
          text-align: center;
          margin-top: 6px;
          margin-bottom: 22px;
          color: rgba(255,255,255,0.6);
          font-size: 14px;
        }

        /* INPUT */
        .input {
          width: 100%;
          padding: 12px 14px;
          margin-bottom: 14px;

          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.12);

          background: rgba(255,255,255,0.06);
          color: #fff;

          outline: none;
          transition: .2s;
        }

        .input::placeholder {
          color: rgba(255,255,255,0.4);
        }

        .input:focus {
          border-color: rgba(79,140,255,0.6);
          box-shadow: 0 0 0 3px rgba(79,140,255,0.15);
        }

        /* BUTTON */
        .btn {
          width: 100%;
          padding: 13px;
          border-radius: 14px;
          border: none;

          font-weight: 800;
          color: white;

          background: linear-gradient(135deg, #2563eb, #4f46e5);

          cursor: pointer;
          transition: .25s;
        }

        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 50px rgba(37,99,235,0.35);
        }

        .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* ALERTS */
        .alert {
          padding: 12px;
          border-radius: 12px;
          margin-bottom: 14px;
          font-size: 13px;
          border: 1px solid;
        }

        .error {
          background: rgba(239,68,68,0.1);
          color: #fca5a5;
          border-color: rgba(239,68,68,0.3);
        }

        .success {
          background: rgba(34,197,94,0.1);
          color: #86efac;
          border-color: rgba(34,197,94,0.3);
        }

        /* LINKS */
        .link {
          display: block;
          text-align: center;
          margin-top: 18px;
          color: #60a5fa;
          font-weight: 700;
          text-decoration: none;
        }

        .link:hover {
          text-decoration: underline;
        }

        /* FOOT NOTE */
        .foot {
          margin-top: 20px;
          font-size: 12px;
          text-align: center;
          color: rgba(255,255,255,0.5);
        }

        @media (max-width: 768px) {
          .card {
            padding: 24px;
          }
          .title {
            font-size: 1.6rem;
          }
        }
      `}</style>

      <div className="card">
        <div className="title">Forgot Password</div>
        <div className="subtitle">
          Enter your email and we’ll send a reset link
        </div>

        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <input
            className="input"
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button className="btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <Link className="link" to="/login">
          Back to login
        </Link>

        <div className="foot">
          Secure reset • One-time link • Auto expiry
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;